import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "consumer-apps-ycp" */ './index')
);
